import React from 'react';
import PropTypes from 'prop-types';
import { newElementId } from '../utils/ids';
import TextareaAutosize from 'react-autosize-textarea';

export class FormGroup extends React.Component {
  // ({ ...props }) {
  componentWillMount() {
    this.htmlFor = newElementId();
  }
  render() {
    const { props } = this;

    const textareaProps = {
      className: 'form-control',
      id: `${this.htmlFor}-input`,
      'aria-describedby': props.help && `${this.htmlFor}-help`,
      placeholder: props.placeholder,
      onChange: props.onChange,
      name: props.name,
      value: props.value,
      rows: props.rows,
      maxRows: props.maxRows,
      onResize: props.onResize,
    };

    return (
      <div className="form-group">
        {this.props.label && <label htmlFor={`${this.htmlFor}-input`}>{props.label}</label>}

        {props.control === 'input' &&
          (props.type === 'radio' || props.type === 'checkbox' ? (
            <div>
              {props.choices.map(([value, display], index) =>
                (props.customForms ? (
                  <div
                    key={index}
                    className={`custom-control custom-${props.type}${
                      props.inline ? ' custom-control-inline' : ''
                    }`}
                  >
                    <input
                      type={props.type}
                      id={`${this.htmlFor}-input-${index}`}
                      name={props.name}
                      className="custom-control-input"
                      value={value}
                      aria-describedby={props.help && `${this.htmlFor}-help`}
                      onChange={props.onChange}
                      checked={
                        props.type === 'checkbox'
                          ? props.values.indexOf(value) >= 0
                          : props.value === value
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor={`${this.htmlFor}-input-${index}`}
                    >
                      {display}
                    </label>
                  </div>
                ) : (
                  <div />
                )))}
            </div>
          ) : (
            <input
              type={props.type}
              className="form-control"
              id={`${this.htmlFor}-input`}
              aria-describedby={props.help && `${this.htmlFor}-help`}
              placeholder={props.placeholder}
              onChange={props.onChange}
              name={props.name}
              value={props.value}
              list={props.datalist && `${this.htmlFor}-datalist`}
            />
          ))}

        {props.control === 'textarea' &&
          (props.autosize ? (
            <TextareaAutosize {...textareaProps} />
          ) : (
            <textarea {...textareaProps} />
          ))}

        {props.control === 'select' && (
          <select
            className={props.customForms ? 'custom-select' : 'form-control'}
            id={`${this.htmlFor}-input`}
            aria-describedby={props.help && `${this.htmlFor}-help`}
            onChange={props.onChange}
            name={props.name}
            value={props.value}
            mutiple={props.mutiple}
          >
            {props.choices.map(([value, display], index) => (
              <option key={index} value={value}>
                {display}
              </option>
            ))}
          </select>
        )}

        {props.datalist && (
          <datalist id={`${this.htmlFor}-datalist`}>
            {props.datalist.map(t => <option key={t} value={t} />)}
          </datalist>
        )}

        {this.props.help && (
          <small id={`${this.htmlFor}-help`} className="form-text text-muted">
            {props.help}
          </small>
        )}
      </div>
    );
  }
}

FormGroup.defaultProps = {
  control: 'input',
  type: 'text',
  label: undefined,
  placeholder: '',
  name: undefined,
  value: undefined,
  help: undefined,
  children: '',
  handleChange: undefined,
  inline: false,
  values: undefined,
  customForms: false,
  multiple: false,
  autosize: false,
};

FormGroup.propTypes = {
  control: PropTypes.oneOf(['input', 'textarea', 'select']),
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  help: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  handleChange: PropTypes.func,
  customForms: PropTypes.bool,
  multiple: PropTypes.bool,
  inline: PropTypes.bool,
  values: PropTypes.array,
  autosize: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Forms.js